import { Popover } from "antd";
import React from "react";
import { useDispatch } from "react-redux";

import { openCandidateComplianceDoc } from "@/reducers/clientcandidatedetail";

const DocumentNameView = ({
  candidate_id,
  document_url = [],
  name = "",
  hasDocuments = false,
  canViewCompliance,
  setOpenedPopoverRow,
  openedPopoverRow,
  document_id = "",
}) => {
  const dispatch = useDispatch();
  const handleFetchCandidateComplianceDoc = (attachmentId = "-") => {
    dispatch(
      openCandidateComplianceDoc({
        candidate_id,
        document_id,
        attachment_id: attachmentId || "-",
      }),
    );
  };
  if (!canViewCompliance) {
    return (
      <span className="truncate text-[14px] font-medium leading-[normal] text-primary hover:text-black">
        {name}
      </span>
    );
  }
  if (!hasDocuments) {
    return (
      <span className="truncate text-[14px] font-medium leading-[normal] text-primary hover:text-primaryHover">
        {name}
      </span>
    );
  }
  if (document_url.length > 1) {
    return (
      <Popover
        content={
          <div className="flex flex-col overflow-hidden rounded-lg">
            {document_url.map((doc, index) => (
              <button
                key={index}
                onClick={() =>
                  handleFetchCandidateComplianceDoc(doc?.attachment_id)
                }
                className="border-b border-primary-100 px-4 py-3 text-[14px] text-primary last:border-b-0 hover:bg-lightblue hover:text-primaryHover"
              >
                Attachment {index + 1}
              </button>
            ))}
          </div>
        }
        rootClassName="z-[1034]"
        trigger="hover"
        placement="right"
        open={openedPopoverRow === document_id}
        onOpenChange={(open) => setOpenedPopoverRow(open ? document_id : null)}
      >
        <button className="group flex items-center gap-2 text-[14px] font-medium leading-[normal] text-primary hover:text-primaryHover">
          {name}
          <span
            className={`transition-linear rounded-md bg-lightblue px-2 py-1 text-center text-[14px] text-primary group-hover:bg-primary group-hover:text-white ${openedPopoverRow === document_id ? "bg-primary text-white" : "text-primary hover:bg-lightblue hover:text-primaryHover"} `}
          >
            {document_url?.length}
          </span>
        </button>
      </Popover>
    );
  }

  return (
    <span
      onClick={() =>
        handleFetchCandidateComplianceDoc(document_url[0]?.attachment_id)
      }
      role="button"
      className="block max-w-[225px] cursor-pointer truncate text-[14px] font-medium leading-[normal] text-primary hover:text-primaryHover"
    >
      {name}
    </span>
  );
};

export default DocumentNameView;
